// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const TRANSFER_PLATES_STEP_SHAPES = [
  {
    stepType: PipelineStepType.TRANSFER_PLATES,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Transfer operations': {
        systemName: 'Transfer operations',
        displayName: 'Transfer operations',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Metadata layers': {
        systemName: 'Metadata layers',
        displayName: 'Metadata layers',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: false
      }
    },
    outputDataShapes: {
      'Destination plates': {
        systemName: 'Destination plates',
        displayName: 'Destination plates',
        kind: PipelineStepDataKind.PLATE,
        isMulti: true,
        isRequired: true
      },
      'Decremented source plates': {
        systemName: 'Decremented source plates',
        displayName: 'Decremented source plates',
        kind: PipelineStepDataKind.PLATE,
        isMulti: true,
        isRequired: false
      }
    },
    config: {
      name: {
        kind: 'string',
        required: true
      },
      plateHeight: {
        kind: 'integer',
        required: true
      },
      plateWidth: {
        kind: 'integer',
        required: true
      },
      plateSchemaId: {
        kind: 'domain',
        required: false,
        types: [
          'PLATE_SCHEMA'
        ]
      },
      columnMapping: {
        kind: 'columnMapping',
        required: true,
        fields: {
          source_plate_id: {
            kind: 'columnReference',
            required: true,
            inputDataName: 'Transfer operations',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.TEXT
              ]
            }
          },
          source_destination_plate_index: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Transfer operations',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.INTEGER,
                LeafType.DECIMAL
              ]
            }
          },
          source_well_position: {
            kind: 'columnReference',
            required: true,
            inputDataName: 'Transfer operations',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.TEXT
              ]
            }
          },
          destination_plate_index: {
            kind: 'columnReference',
            required: true,
            inputDataName: 'Transfer operations',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.INTEGER,
                LeafType.DECIMAL
              ]
            }
          },
          destination_well_position: {
            kind: 'columnReference',
            required: true,
            inputDataName: 'Transfer operations',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.TEXT
              ]
            }
          },
          transfer_amount: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Transfer operations',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.INTEGER,
                LeafType.DECIMAL
              ]
            }
          },
          transfer_unit_id: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Transfer operations',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.TEXT
              ]
            }
          },
          transfer_unit_version: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Transfer operations',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.INTEGER,
                LeafType.DECIMAL
              ]
            }
          },
          diluent_amount: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Transfer operations',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.INTEGER,
                LeafType.DECIMAL
              ]
            }
          },
          diluent_unit_id: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Transfer operations',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.TEXT
              ]
            }
          },
          diluent_unit_version: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Transfer operations',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.INTEGER,
                LeafType.DECIMAL
              ]
            }
          },
          diluent_entity_id: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Transfer operations',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.TEXT
              ]
            }
          },
          final_volume_amount: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Transfer operations',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.INTEGER,
                LeafType.DECIMAL
              ]
            }
          },
          final_volume_unit_id: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Transfer operations',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.TEXT
              ]
            }
          },
          final_volume_unit_version: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Transfer operations',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.INTEGER,
                LeafType.DECIMAL
              ]
            }
          }
        }
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
